import React from 'react';
import TeamCard from '../Components/TeamCard/TeamCard';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import useSiteContent, { imageUrl } from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';

const Team = ({ scrollPosition }) => {
  const { data, unavailable } = useSiteContent('team');
  return <div className="main_page_container">
    <ContentNotice unavailable={unavailable} />
    {Object.entries({ Officer: 'Officers', LE: 'Lead Engineers', NCO: 'Non-Commissioned Officers' }).map(([office, title]) => <section key={office}>
      <h1 className="page_title">{title}</h1>
      <div className="team_grid">
        {data.items.filter(member => member.office === office).map((member, index) => <TeamCard
          key={index} {...member} image={imageUrl(member.image)} scrollPosition={scrollPosition}
        />)}
      </div>
    </section>)}
  </div>;
};
export default trackWindowScroll(Team);
